<template>
	<div class="password-form">
		<header-simple :title="$t('base.profile.change_password')" :subtitle="'Information about the user account.'"></header-simple>
		<!-- <success-box v-if="success" @close="reset">{{ success }}</success-box>
		<form v-else @submit.prevent="validateAndSubmit">
			<input-password v-model="model.password_old" name="password_old" :placeholder="$t('labels.profile.old_password')" rules="required|min:8"/>
			<input-password v-model="model.password_new" name="password_new" :placeholder="$t('labels.profile.new_password')" rules="required|min:8"/>
			<input-password v-model="model.password_new_confirm" name="password_new_confirm" :placeholder="$t('labels.profile.confirm_new_password')" :rules="'required|confirmed:'+model.password_new"/>
			<error-box v-if="error" :error="error"/>
			<button-submit :loading="loading">{{ $t('buttons.actions.update_password') }}</button-submit>
		</form> -->
		<form @submit.prevent="validateAndSubmit">
			<form-panel :error="error" :loading="loading">
				<input-password v-model="model.password_old" name="password_old" :placeholder="$t('labels.profile.old_password')" rules="required|min:8"/>
				<input-password v-model="model.password_new" name="password_new" :placeholder="$t('labels.profile.new_password')" rules="required|min:8"/>
				<input-password v-model="model.password_new_confirm" name="password_new_confirm" :placeholder="$t('labels.profile.confirm_new_password')" :rules="'required|confirmed:'+model.password_new"/>
				<template v-slot:footer>
					<button-submit :loading="loading">{{ $t('buttons.actions.update_password') }}</button-submit>
				</template>
			</form-panel>
		</form>
	</div>
</template>

<script>
import HeaderSimple from '@/modules/ui/HeaderSimple'
import FormPanel from '@/modules/ui/FormPanel'
export default {
	props: [
		'user_uid'
	],
	components: {
		HeaderSimple,
		FormPanel
	},
	data () {
		return {
			success: null,
			error: null,
			loading: false,
			model: {
				password_old: '',
				password_new: '',
				password_new_confirm: ''
			}
		}
	},
	computed: {
		user () {
			return this.$store.getters.getUser
		}
	},
	methods: {
		reset () {
			this.success = null
			this.error = null
			this.loading = false
			this.model = {
				password_old: '',
				password_new: '',
				password_new_confirm: ''
			}
		},
		validateAndSubmit () {
			this.$validator.validateAll().then(result => {
				if (result) this.updatePassword()
			})
		},
		updatePassword () {
			this.success = null
			this.error = null
			this.loading = true
			this.$api.users.password.edit(this, this.user_uid, this.model)
				.then(response => {
					this.$root.$emit('add-floating-box', { type: 'success', title: 'Success', message: 'Password updated with success.' })
				})
				.catch(error => {
					this.error = error
					this.$root.$emit('add-floating-box', { type: 'error', title: 'Error', message: 'Issue try to update password. Try again please.' })
				})
				.finally(() => {
					this.loading = false
				})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/accountinformation/PasswordForm.vue